export default "__VITE_ASSET__CEoe1DXk__"